/*
 * Expands/collapses a Goal Plan's ~25 $0 component lines in the cart,
 * hidden behind one "N meals included" summary row by default (see
 * snippets/cart-products.liquid). Purely presentational — the real <tr>
 * rows and their data are already in the DOM, this only toggles their
 * `hidden` attribute, so nothing about the actual cart/order content
 * changes. Delegated on document so it keeps working after Shopify
 * replaces the cart drawer/page section's innerHTML on every cart update
 * (a direct listener on the button itself wouldn't survive that swap).
 */
(function () {
  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-rgoal-collapse-toggle]');
    if (!toggle) return;

    var group = toggle.getAttribute('data-rgoal-collapse-toggle');
    var root = toggle.closest('table, .cart-items') || document;
    var expanded = toggle.getAttribute('aria-expanded') === 'true';

    root.querySelectorAll('[data-rgoal-collapse-group="' + group + '"].rgoal-collapse-line').forEach(function (row) {
      row.hidden = expanded;
    });
    toggle.setAttribute('aria-expanded', String(!expanded));
  });
})();
